export function getUserFullName(user) {
    return user ? user.firstName + " " + user.lastName : "";
}
